/**
 * =============================================================================
 * Hook do CHIEU NGUOC — nguoi dung tu trang chien dich quay ve ShweDeal
 * Nguon: sheet 12_KB_Event ba dich vu, event enter_service_from_hub (P0)
 *
 * Dat o LayoutApp vi LayoutApp boc MOI route: nhiem vu cua chien dich co the
 * tro ve bat ky man nao cua ShweDeal, khong chi trang Home.
 *
 * Luong:
 *   [trang chien dich] select_mission
 *        -> https://<shwedeal>/<man dich>?mission_id=sd_buy_1_deal
 *   [ShweDeal] enter_service_from_hub   <-- hook nay
 *        -> ... nguoi dung lam nhiem vu ...
 *
 * Chi ban MOT lan moi lan tai trang, va chi khi URL co mission_id.
 *
 * complete_mission DA BO: ShweDeal khong quan sat duoc thoi diem chien dich
 * ghi nhan nhiem vu (nhat la 8 nhiem vu nap/goi qua USSD/SMS). THD-22 lay so
 * tu CMS Big Promotion, khong lay tu GA4.
 * =============================================================================
 */
import { useEffect } from "react";
import { trackEnterServiceFromHub } from "./thadingyut";

export default function useMissionEntry() {
  useEffect(() => {
    trackEnterServiceFromHub();
  }, []);
}
